import React, { useCallback, useEffect, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    props.setPrimaryParameters({ ...props.primaryParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              attr5="Y"
              topSelected="전체"
              onChange={handleChangeField}
              value={props.primaryParameters.schPlantCd}
              className="datainput"
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 공급업체
            </div>
            <input
              type="text"
              name="schVndrNm"
              onChange={handleChangeField}
              className="datainput"
              value={props.primaryParameters.schVndrNm}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 실공급업체
            </div>
            <input
              type="text"
              name="schRvndrNm"
              onChange={handleChangeField}
              className="datainput"
              value={props.primaryParameters.schRvndrNm}
            />
          </li>

          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSwghtDt"
                id="schSwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.primaryParameters.schSwghtDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEwghtDt"
                id="schEwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.primaryParameters.schEwghtDt}
              />
            </div>
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 차량번호
            </div>
            <input
              type="text"
              name="schVhclNo"
              onChange={handleChangeField}
              className="datainput"
              value={props.primaryParameters.schVhclNo}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 배차상태
            </div>
            <SelectBox
              mastCd="TRANS_STATUS_CD"
              name="schTransStatusCd"
              topSelected="전체"
              onChange={handleChangeField}
              className="datainput"
              value={props.primaryParameters.schTransStatusCd}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
